import { faEdit, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {
    AtualizarOrdemEtapaController,
    DeletarEtapaController,
    ListarEtapasController,
} from "../../../../../../../../Controllers/Geral/Etapas/EtapasControllers";
import { IEtapa } from "../../../../../../../../Interfaces/Geral/Etapas/EtapasInterfaces";
import ModalComponent from "../../../../../../../Modais";
import { IComponentModal } from "../../../../../../../Modais/IModalComponent";
import CadastrarEtapa from "./CadastrarEtapa";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useCallback } from "react";
import EditarEtapa from "./EditarEtapa";
import Swal from "sweetalert2";
import SpinnerComponent from "../../../../../../../Loding/Spinner";

import "./styles.css";
import useMedia from "../../../../../../../../hooks/useMedia";
import { IModuloCategoriaAtendimento } from "../../../../../../../../Interfaces/Geral/GestaoDeCadastro/CategoriaAtendimento/CategoriaAtendimentoInterface";

interface IGerenciarEtapasProps {
    idCategoria: number;
    idModulo: number;
    ID_CATEGORIA_ATENDIMENTO_TIPO_CASO: number;
    tipoCaso?: IModuloCategoriaAtendimento;
}

export default function GerenciarEtapas(props: IGerenciarEtapasProps) {
    const [etapas, setEtapas] = useState<Array<IEtapa>>([]);
    const [loading, setLoading] = useState(false);

    const screenSize = useMedia();

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const updateEtapas = useCallback(() => {
        if (props.idModulo && props.idCategoria) {
            const moduloValidation =
                props.idModulo === 2 || props.idModulo === 5
                    ? props.idCategoria
                    : 0;
            setLoading(true);
            ListarEtapasController(props.idModulo, moduloValidation)
                .then((res) => {
                    res.sort(
                        (a, b) =>
                            a.NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO -
                            b.NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                    );
                    setEtapas(res);
                })
                .finally(() => setLoading(false));
        }
    }, [props.idModulo, props.idCategoria]);

    useEffect(() => {
        updateEtapas();
    }, [updateEtapas]);

    return (
        <>
            <div className="card card-custom">
                <div className="card-header">
                    <h3 className="card-title w-100 d-flex justify-content-between">
                        Etapas {props.tipoCaso?.DS_TIPO_CASO}
                        {props.idModulo === 2 || props.idModulo === 5 ? (
                            <button
                                className="btn btn-success font-weight-bold mr-2"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        Component: () => (
                                            <CadastrarEtapa
                                                setShow={setShow}
                                                updateList={updateEtapas}
                                                ID_CATEGORIA_ATENDIMENTO_TIPO_CASO={
                                                    props.ID_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                }
                                            />
                                        ),
                                        noFooter: true,
                                        noHeader: true,
                                    });
                                }}
                            >
                                <FontAwesomeIcon
                                    icon={faPlus}
                                    size="lg"
                                    className="mr-2"
                                />{" "}
                                Nova Etapa
                            </button>
                        ) : null}
                    </h3>
                </div>
                <div className="card-body">
                    {loading ? (
                        <SpinnerComponent />
                    ) : (
                        etapas.length > 0 && (
                            <DragDropContext
                                onDragEnd={(result) => {
                                    if (
                                        result.destination?.index &&
                                        result.destination.index >
                                            etapas[0]
                                                .NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO &&
                                        result.destination.index <
                                            etapas[etapas.length - 1]
                                                .NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO &&
                                        result.source.index !==
                                            result.destination.index
                                    ) {
                                        const idEtapa = Number.parseInt(
                                            result.draggableId
                                        );
                                        setLoading(true);
                                        AtualizarOrdemEtapaController(
                                            idEtapa,
                                            result.destination.index
                                        )
                                            .then(updateEtapas)
                                            .catch(() => setLoading(false));
                                    }
                                }}
                            >
                                <Droppable
                                    droppableId="EtapasDroppable"
                                    direction={
                                        screenSize === "xs"
                                            ? "vertical"
                                            : "horizontal"
                                    }
                                >
                                    {(providedDrop) => (
                                        <>
                                            <ul
                                                className="px-3 nav nav-pills nav-success row row-paddingless flex-column flex-nowrap flex-sm-row custom-scroll xs-hide-scroll pb-2 etapas"
                                                ref={providedDrop.innerRef}
                                                {...providedDrop.droppableProps}
                                            >
                                                {etapas.map((etapa) => (
                                                    <div
                                                        className="mx-3 w-100"
                                                        key={
                                                            etapa.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                        }
                                                    >
                                                        <Draggable
                                                            draggableId={`${etapa.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}`}
                                                            index={
                                                                etapa.NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                            }
                                                            isDragDisabled={
                                                                !etapa.FL_ATIVO
                                                            }
                                                            disableInteractiveElementBlocking={
                                                                !etapa.FL_ATIVO
                                                            }
                                                        >
                                                            {(providedDrag) => (
                                                                <li
                                                                    className={`d-flex col-sm flex-grow-1 flex-shrink-0 mb-3 mb-lg-0 etapa ws-nowrap`}
                                                                    key={
                                                                        etapa.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                                    }
                                                                    ref={
                                                                        providedDrag.innerRef
                                                                    }
                                                                    {...providedDrag.draggableProps}
                                                                    {...providedDrag.dragHandleProps}
                                                                >
                                                                    <div className="etapa-gestao-menu">
                                                                        <div
                                                                            role="button"
                                                                            className="d-flex text-white text-hover-primary"
                                                                            onClick={() => {
                                                                                setModal(
                                                                                    {
                                                                                        Component:
                                                                                            () => (
                                                                                                <EditarEtapa
                                                                                                    dsEtapa={
                                                                                                        etapa.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                                                                    }
                                                                                                    idEtapa={
                                                                                                        etapa.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                                                                    }
                                                                                                    flAtivo={
                                                                                                        etapa.FL_ATIVO
                                                                                                    }
                                                                                                    lstEtapas={
                                                                                                        etapas
                                                                                                    }
                                                                                                    updateList={
                                                                                                        updateEtapas
                                                                                                    }
                                                                                                    idModulo={
                                                                                                        props.idModulo
                                                                                                    }
                                                                                                />
                                                                                            ),
                                                                                        noHeader:
                                                                                            true,
                                                                                        noBody: true,
                                                                                        size: "lg",
                                                                                    }
                                                                                );
                                                                                setShow(
                                                                                    true
                                                                                );
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon
                                                                                icon={
                                                                                    faEdit
                                                                                }
                                                                                size={
                                                                                    "lg"
                                                                                }
                                                                            />
                                                                        </div>
                                                                        {etapa.FL_ATIVO && (
                                                                            <div
                                                                                role="button"
                                                                                className="d-flex text-white text-hover-danger"
                                                                                onClick={() => {
                                                                                    Swal.fire(
                                                                                        {
                                                                                            title: "Deseja deletar esta etapa?",
                                                                                            icon: "info",
                                                                                            buttonsStyling:
                                                                                                false,
                                                                                            confirmButtonText:
                                                                                                "<i class='la la-check'></i> Sim!",
                                                                                            showCancelButton:
                                                                                                true,
                                                                                            cancelButtonText:
                                                                                                "<i class='la la-thumbs-down'></i> Não",
                                                                                            customClass:
                                                                                                {
                                                                                                    confirmButton:
                                                                                                        "btn btn-outline-success",
                                                                                                    cancelButton:
                                                                                                        "btn btn-default",
                                                                                                },
                                                                                        }
                                                                                    ).then(
                                                                                        (
                                                                                            result
                                                                                        ) => {
                                                                                            if (
                                                                                                result.isConfirmed
                                                                                            ) {
                                                                                                DeletarEtapaController(
                                                                                                    etapa.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                                                                ).then(
                                                                                                    updateEtapas
                                                                                                );
                                                                                            }
                                                                                        }
                                                                                    );
                                                                                }}
                                                                            >
                                                                                <FontAwesomeIcon
                                                                                    icon={
                                                                                        faTrash
                                                                                    }
                                                                                    size={
                                                                                        "lg"
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    <span
                                                                        className={`border p-1 pt-2 d-flex flex-grow-1 rounded flex-column align-items-center`}
                                                                    >
                                                                        <span className="font-size-h5">
                                                                            {
                                                                                etapa.NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                                            }
                                                                        </span>
                                                                        <span className="py-1 font-weight-bold text-center d-flex align-items-center">
                                                                            {
                                                                                etapa.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                                            }
                                                                        </span>
                                                                    </span>
                                                                </li>
                                                            )}
                                                        </Draggable>
                                                    </div>
                                                ))}
                                                {providedDrop.placeholder}
                                            </ul>
                                        </>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        )
                    )}
                </div>
            </div>

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
